import React, { Component } from 'react';
import { Button, message, Select } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';
import ExportSelectRangeModal from './ExportSelectRangeModal';

const dateFormat = 'YYYY-MM-DD';
class Filter extends Component {
    render() {
        const { businessList, ...rest } = this.props;
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const filters = [{
            name: '统计时间段',
            key: 'begin',
            type: 'datePicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '至',
            key: 'end',
            type: 'datePicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '领域leader',
            key: 'leaderUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}
const yearFormat = 'YYYY';
const monthFormat = 'MM';
let year = moment().format(yearFormat);
let month1 = moment().format(monthFormat);
let beginShow = '';
let endShow = year + "-" + month1 + "-25";
if (month1 == 1) {
    beginShow = (year - 1) + "-" + '12' + '-26';
} else {
    beginShow = year + "-" + (month1 - 1) + '-26';
}

class PatientVisitHour extends Component {
    
    state = {
        data: [],
        businessList: [],
        loading: false,
        sortParams: {},
        searchParams: {
            //begin: moment().startOf('month').format(dateFormat),
            //begin: moment(year + "-" + month1 + "-30").format(dateFormat),
            begin: moment(beginShow).format(dateFormat),
            //end: moment().endOf('month').format(dateFormat),
            end: moment(endShow).format(dateFormat),
        },
        curParams: {
            // begin: moment().startOf('month').format(dateFormat),
            // end: moment().endOf('month').format(dateFormat),
            begin: moment(beginShow).format(dateFormat),
            end: moment(endShow).format(dateFormat),
        },
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryInvCRCWorkType,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...curParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {
                ...searchParams,
            },
        }, () => {
            this.loadData();
        });
    }

    showExportModal = () => {
        this.exportSelectRangeRef.show();
    }

    export = (exportParams) => {
        const { sortParams, curParams } = this.state;
        const url = API_URL.dashboard.exportInvCRCWorkType;
        this.addToDownloadSite({ ...sortParams, ...curParams, ...exportParams }, url, 'Report_CRC_Work_Type');
    }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: (res) => {
                const { success, asynchronousExportId } = res;
                message.success(success);
                const params = { ...searchArray, asynchronousExportId }
                ExportUtil.export(params, null, url);
            },
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: '日期',
            dataIndex: 'manHourDateShow',
            key: 'manHourDateShow',
            fixed: 'left',
            width: 80,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'mainCode',
            key: 'mainCode',
            width: 100,
        }, {
            title: '领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 80,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 150,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 80,
        }, {
            title: '角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 70,
        }, {
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 90,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 90,
        }, {
            title: '直线主管',
            dataIndex: 'leaderUser',
            key: 'leaderUser',
            width: 100,
        }, {
            title: '工作类型',
            dataIndex: 'workType',
            key: 'workType',
            width: 80,
        }, {
            title: '工作内容',
            dataIndex: 'workContent',
            key: 'workContent',
            width: 120,
        }, {
            title: '工时',
            dataIndex: 'workHour',
            key: 'workHour',
            width: 80,
        }, {
            title: '筛选编号',
            dataIndex: 'filterPatientCode',
            key: 'filterPatientCode',
            width: 80,
        }, {
            title: '访视次数',
            dataIndex: 'visitTypeName',
            key: 'visitTypeName',
            width: 80,
        }, {
            title: '访视类型',
            dataIndex: 'visitConfigValue',
            key: 'visitConfigValue',
            width: 100,
        }, {
            title: '访视数量',
            dataIndex: 'visitNum',
            key: 'visitNum',
            width: 80,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams, businessList } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    businessList={businessList}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={this.showExportModal} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <TableC
                    data={data}
                    scrollY={500}
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    className="patientVisitHour"
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
                <ExportSelectRangeModal key='1' ref={el => { this.exportSelectRangeRef = el; }} exportSelectRange = {this.export.bind(this)}/>
            </div>
        );
    }
}

export default PatientVisitHour;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/patientVisitHour.js